import { Workspace } from '@aibees/shared/definition';

export interface CreateSearchListRequest {
  type: SearchListType;
  values: string[];
  description?: string;
  temp?: boolean; // if true, the search list will be deleted after a certain time by the backend
}

export enum SearchListType {
  COMPANY_ID = 'COMPANY_ID',
  COMPANY_LINKEDIN = 'COMPANY_LINKEDIN',
  COMPANY_DOMAIN = 'COMPANY_DOMAIN',
  COMPANY_NAME = 'COMPANY_NAME',
  PERSON_ID = 'PERSON_ID',
  PERSON_LINKEDIN = 'PERSON_LINKEDIN',
}

export interface SearchList {
  id: string;
  workspace: {
    id: Workspace['id'];
    user: Workspace['user'];
  };
  type: SearchListType;
  values: string[];
  description: string;
  created: string;
  records?: number; // undefined means 0 records
}
